/* eslint-disable import/no-dynamic-require */
import React from 'react';
import WeixinRuntime from './wxRuntime';

export function rootContainer(container: React.ReactNode) {
  return React.createElement(
    WeixinRuntime as any,
    null,
    container,
  );
}
